<template>
    <Modal :value="show"
        :closable="false"
        :mask-closable="false"
        :title="'请选择预售周期 ' + year"
        @on-ok="onClose"
        @on-cancel="onClose">

        <Row :gutter="16">
            <Col span="24">
            <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                <Checkbox :indeterminate="indeterminate"
                    :value="checkAll"
                    @click.prevent.native="handleCheckAll">全选</Checkbox>
            </div>
            </Col>
        </Row>
        <Row :gutter="16">

            <CheckboxGroup v-model="checkedWeeks"
                size="default"
                @on-change="checkAllGroupChange">
                <Col v-for="w in (displayWeekRange || weekRange)"
                    :key="w.value"
                    span="6">
                <Checkbox :label="w.value"
                    size="default">{{ w.label }}</Checkbox>
                </Col>
            </CheckboxGroup>

        </Row>
    </Modal>
</template>

<script>
import { getWeek } from '@/libs/logic';

export default {
    name: 'WeekModal',
    data() {
        return {
            show: false,
            weekRange: [],
            displayWeekRange: [], // 用于显示的周数据，会被过滤
            checkedWeeks: [],
            indeterminate: false,
            checkAll: false,
            year: 0,
            isFirstOpen: true // 标识是否首次打开
        };
    },
    mounted() {
    },
    methods: {
        setCheckedWeeks(weeks) {
            this.checkedWeeks = weeks;
        },
        initWeeks(weeks){
            this.weekRange = new Array();
            for (let i = 1; i <= weeks.length; i++) {
                this.weekRange.push({
                    label: `第${i}周`,
                    value: i
                });
            }
        },
        showModal(year) {
            this.year = year;
            let now = new Date();
            let curYear = now.getFullYear();
            let curWeek = getWeek();

            // 重置 weekRange 到原始状态，避免过滤逻辑重复应用
            if (this.weekRange.length === 0) {
                // 如果 weekRange 为空，说明是第一次调用，需要重新初始化
                console.warn('weekRange 为空，请确保先调用 initWeeks 方法');
                this.initWeeks(Array.from({ length: 53 }, (_, i) => i + 1));
            }

            // 创建 weekRange 的副本进行过滤，避免修改原始数据
            let filteredWeekRange = [...this.weekRange];
            if (year === curYear) {
                filteredWeekRange = filteredWeekRange.filter(e => {
                    return e.value >= curWeek;
                });
            }

            // 更新显示用的 weekRange，但保留原始数据
            this.displayWeekRange = filteredWeekRange;

            // 仅在首次打开时默认全选所有可用的周
            if (this.isFirstOpen) {
                this.checkedWeeks = this.displayWeekRange.map(i => i.value);
                this.checkAll = true;
                this.indeterminate = false;
                this.isFirstOpen = false; // 标记已不是首次打开
            }

            this.show = true;
        },
        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            }
            else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            const currentWeekRange = this.displayWeekRange || this.weekRange;
            if (this.checkAll) {
                this.checkedWeeks = currentWeekRange.map(i => {
                    return i.value;
                });
            }
            else {
                this.checkedWeeks = [];
            }
        },
        checkAllGroupChange(data) {
            const currentWeekRange = this.displayWeekRange || this.weekRange;
            if (data.length === currentWeekRange.length) {
                this.indeterminate = false;
                this.checkAll = true;
            }
            else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            }
            else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        onClose() {
            this.show = false;
            this.$emit('close', this.checkedWeeks);
        }
    }
};
</script>

<style scoped>
</style>
